// Срез в верхней панели — период и направление звонков — общий для всех отчётных разделов
// и хранится в App. Какой раздел его использует, решается здесь и только здесь.
//
// Правило одно: контрол виден только там, где действительно работает. Раньше селект
// направления стоял над каждым разделом, а доходил только до KPI-полосы и «Общей
// статистики»: в «Сотрудниках» он ничего не менял, а у журнала был свой, второй селект
// того же смысла. Фильтры, которые принадлежат одному разделу (сотрудник, отдел, фильтры
// по результатам анализа), живут в шапке раздела, а не здесь.

// Разделы без временного среза: ни выбора периода, ни верхней KPI-полосы. Это служебные
// экраны, а не отчёты, и панель над ними только сбивала бы с толку.
export const SECTIONS_WITHOUT_PERIOD = new Set(['settings', 'help']);

// Разделы, где направление доходит до каждого запроса раздела.
export const SECTIONS_WITH_DIRECTION = new Set(['dashboard', 'employees', 'calls', 'call-paths', 'complaints']);

// Период есть, направления нет. «Клиенты» уже делят звонки на входящие и исходящие
// столбцами таблицы, «Пропущенные» — только про входящие, у «Интеграций» отчёта по звонкам
// нет вовсе. Список явный, а не «все остальные»: так сторож в тесте заставляет решить
// вопрос для каждого нового раздела.
export const SECTIONS_PERIOD_ONLY = new Set(['clients', 'missed', 'integrations']);

// Период управляет только верхней KPI-полосой: самому разделу временной срез не нужен
// (справочник номеров). Панель здесь ради единого вида с остальными разделами, поэтому
// там, где KPI-полосы нет, нет и панели — календарь ни на что бы не влиял.
export const SECTIONS_KPI_ONLY = new Set(['number-filters']);

export const ALL_CALL_TYPES = 'all';

// На десктопе KPI видны над каждой вкладкой с панелью. В мобильной раскладке плитки
// в столбик занимают полтора экрана, и до содержимого вкладки приходилось пролистывать —
// там они остаются только на «Общей статистике».
export const hasKpiStrip = (section, isDesktop) => isDesktop || section === 'dashboard';

// Неизвестный раздел ведёт себя как раньше — с панелью периода.
export const hasPeriodBar = (section, isDesktop = true) =>
  !SECTIONS_WITHOUT_PERIOD.has(section)
  && (!SECTIONS_KPI_ONLY.has(section) || hasKpiStrip(section, isDesktop));

export const hasDirectionFilter = (section) => SECTIONS_WITH_DIRECTION.has(section);

// Направление, которым считает раздел. Где селекта нет, KPI-полоса считает по всем
// звонкам: иначе выбор, сделанный в другом разделе, молча сужал бы цифры без единого
// видимого признака. Сам выбор при этом хранится в App и возвращается вместе с разделом.
export const effectiveCallType = (section, callType) =>
  hasDirectionFilter(section) && callType ? callType : ALL_CALL_TYPES;
